import { render, staticRenderFns } from "./TaskTemplateList.vue?vue&type=template&id=7a479cd4"
import script from "./TaskTemplateList.vue?vue&type=script&lang=js"
export * from "./TaskTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports